<template>
  <div style="width: 100%" class="fill-height">
    <v-container>
      <v-row class="d-flex justify-end pt-3 pb-1 pr-3">
        <v-btn class="comm-add-btn" elevation="0" @click="openAddCommunication">
          <v-icon left small>mdi-plus</v-icon>
          Dodaj kontakt
        </v-btn>
      </v-row>
      <v-row style="margin-top: 8px" class="d-flex justify-center">
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <div class="comm-rows-body">
            <v-card v-for="(item, i) in sortedComms" :key="i" class="comm-card">
              <v-row class="ma-0 align-center" style="min-height: 60px;">
                <div style="width: 20%; padding: 8px 16px; min-width: 0; overflow: hidden;">
                  <div class="comm-name one-liner-text text-capitalize">{{ item.type }}</div>
                </div>
                <div style="width: 25%; padding: 8px 16px; min-width: 0; overflow: hidden;">
                  <div class="comm-cell one-liner-text">{{ item.value }}</div>
                </div>
                <div style="flex: 1; padding: 8px 16px; min-width: 0; overflow: hidden;">
                  <div class="comm-cell" v-html="showUsages(item.type, item.usage)"></div>
                </div>
                <div style="padding: 8px 8px;">
                  <v-btn icon small @click.stop="openEditCommunication(item)">
                    <v-icon color="#3989C9">mdi-pencil-outline</v-icon>
                  </v-btn>
                </div>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      <add-communication ref="addCommunication"></add-communication>
      <edit-communication ref="editCommunication"></edit-communication>
    </v-container>
  </div>
</template>
<script>
import state from '@/state'
import AddCommunication from '@/modules/point-of-sale/components/communication-configuration/AddCommunication'
import EditCommunication from '@/modules/point-of-sale/components/communication-configuration/EditCommunication'
import { df } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import InfiniteLoading from 'vue-infinite-loading'
import applicationSettings from '@/mixins/applicationSettings'

export default {
  name: 'CommunicationConfiguration',
  mixins: [applicationSettings],
  components: { AddCommunication, EditCommunication, InfiniteLoading },
  data: () => ({
    location: undefined,
    comms: [],
    selectedComm: undefined,
    showPass: false,
    sortedComms: [],
    listeners: [],
    availableComms: []
  }),
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getCommTypes()
  },
  beforeDestroy () {
  },
  methods: {
    getCommTypes () {
      const listener = df.doc('project_constants/communications').onSnapshot(doc => {
        this.availableComms = doc.data().types
      })
      this.listeners.push(listener)
    },
    showUsages (type, usages) {
      var readableusage = ''
      if (usages && usages.length > 0) {
        usages.forEach((usage, key) => {
          this.availableComms.forEach(aC => {
            if (aC.id === type) {
              aC.available_usage.forEach(u => {
                if (u.id === usage) {
                  readableusage += u.text
                  readableusage += '<br/>'
                }
              })
            }
          })
        })

        return readableusage
      }
    },
    openAddCommunication () {
      this.$refs.addCommunication.open()
    },
    openEditCommunication (comm) {
      this.$refs.editCommunication.open(comm, this.availableComms)
    },
    modifyComms (changedComm) {
      let found = false
      this.comms.forEach((comm, key) => {
        if (comm.id === changedComm.id) {
          found = true
          this.comms[key] = changedComm
        }
      })

      if (!found) {
        this.comms.push(changedComm)
      }

      this.sortedComms = clone(this.comms)
    },
    infiniteHandler ($state) {
      if (state.getCurrentCompany().id !== '') {
        const query = df.collection(`company_communications/${state.getCurrentCompany().id}/communications`)
        const listener = query
          .onSnapshot((doc) => {
            doc.docs.forEach((rec) => {
              this.modifyComms(rec.data())
            })
            $state.complete()
          })

        this.listeners.push(listener)
      } else {
        $state.complete()
      }
    }
  }
}
</script>
<style scoped>
.comm-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.comm-card {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  overflow: hidden !important;
  margin-bottom: 4px !important;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.comm-card:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.comm-name {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}

.comm-cell {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
}

.comm-add-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 40px !important;
  min-height: 40px !important;
  white-space: nowrap;
}
.comm-add-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: none !important;
}
.comm-add-btn .v-icon {
  color: #00BCD4 !important;
  font-size: 17px !important;
}
</style>
